<template>
  <div class="field" :class="question.errorMessage ? 'errorBorder' : ''">
    <div class="text title_text">
      <span>{{ question.num }}、</span>{{ question.title }}
      <span v-if="question.must === 1" class="req">*</span>
    </div>
    <div class="scale-div">
      <table>
        <template v-for="(stitle,sindex) in question.subtitle">
          <tr>
            <td colspan="9" class="tdtitle">{{ stitle }}</td>
          </tr>
          <tr>
            <td v-for="(item,index) in option6">
              <a class="rate-off" :class="selected[sindex][index]?'rate-on rate-ontxt':''"
                 @click="selectCurrent(index,question.num,question.type,item,sindex)"></a>
              {{ item }}
            </td>
          </tr>
        </template>
      </table>
    </div>
    <div class="errorMessage">{{ question.errorMessage }}</div>
  </div>
</template>
<script>
export default {
  props: {
    question: Object
  },
  data() {
    return {
      option6: ['是', '不确定', '否'],
      selected: [
        [false, false, false, false, false, false, false, false, false],
        [false, false, false, false, false, false, false, false, false],
        [false, false, false, false, false, false, false, false, false],
        [false, false, false, false, false, false, false, false, false],
        [false, false, false, false, false, false, false, false, false]
      ]
    }
  },
  methods: {
    selectCurrent: function (index, num, type, item, s) {
      let value = [false, false, false, false, false, false, false, false, false]
      value[index] = true
      if (s + 1) {
        this.$set(this.selected, s, value)
      } else {
        this.$set(this.selected, 0, value)
      }
      this.$emit("listenToChildEvent", index + 1, num, type, s + 1);
    }
  }
}
</script>
<style lang="stylus" scoped>
table {
  width: 94%;
  background: #fff;
  margin: auto;
  padding: 0.1rem;
}

table th {
  padding: 0.16rem 0;
  width: 9%;
  text-align: center;
  font-weight: normal;
}

table th:first-child, table th:last-child {
  width: 13%;
}

table tr .tdtitle {
  text-align: left;
  padding: 0.1rem 0 0 0;
  border: none;
}

table td {
  border-top: 1px solid #dbdbdb;
  padding: 0.2rem 0;
  text-align: center;
}

.rate-off {
  width: 21px;
  height: 21px;
  text-decoration: none;
  border-radius: 30px;
  color: #333;
  border: 1px solid #cacece;
  cursor: default;
  display: inline-block;
  background: #fafafa;
  line-height: 19px;
  text-align: center;
}

.rate-on {
  background-color: #53a4f4 !important;
  border: 1px solid #53a4f4;
  position: relative;
  color: #fff;
}

a.rate-ontxt:after {
  question: ' ';
  width: 10px;
  height: 10px;
  border-radius: 50px;
  position: absolute;
  top: 5px;
  background: #fff;
  text-shadow: 0px;
  left: 5px;
  font-size: 32px;
}

.req {
  color: red
}

.title_text {
  font-weight: bold;
}
</style>
